import { message } from 'antd';

const ToastErrorMessage = (hasError) => {
  if (hasError) {
    message.error({
      content: "System encountered an issue. Please try again or connect with the system administrator.",
      duration: 10,
    });
  }
};

export default ToastErrorMessage;
